<template>
  <div class="pb-3">
    <section id="api_tasks_edit" class="pt-2">
      <h4 class="pb-2">Изменение задачи</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">POST</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}/:id/edit</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Общие параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>id</td>
                  <td>целое число</td>
                  <td>обязательный параметр</td>
                  <td>ID задачи</td>
                </tr>
                <tr>
                  <td>name</td>
                  <td>строка</td>
                  <td>от 3 до 64 символов</td>
                  <td>название задачи</td>
                </tr>
                <tr>
                  <td>frequency</td>
                  <td>целое число</td>
                  <td>может содержать 1, 3, 5, 10, 15, 30, 60, 180, 360, 720 или 1440</td>
                  <td>частота выполнения задачи (в минутах)</td>
                </tr>
                <tr>
                  <td>group_id</td>
                  <td>целое число</td>
                  <td></td>
                  <td>ID категории</td>
                </tr>
                <tr>
                  <td>contacts</td>
                  <td>массив</td>
                  <td></td>
                  <td>ID контактов для уведомлений по задаче</td>
                </tr>
                <tr>
                  <td>settings</td>
                  <td>массив</td>
                  <td></td>
                  <td>настройки задачи (подробнее в описании параметров каждого типа задачи)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры проверки сервера (PING)</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>value</td>
                  <td>строка</td>
                  <td></td>
                  <td>IP адрес сервера или доменное имя</td>
                </tr>
                <tr>
                  <td>settings.loss</td>
                  <td>целое число</td>
                  <td>может содержать от 1 до 100</td>
                  <td>процент доспустимых потерь сетевых пакетов</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры проверки сайтов (HTTP)</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>value</td>
                  <td>строка</td>
                  <td></td>
                  <td>URL адрес</td>
                </tr>
                <tr>
                  <td>settings.keyword</td>
                  <td>строка</td>
                  <td>может содержать от 2 до 128 символов</td>
                  <td>ключевое слово для поиска в первых 10 килобайтах</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -X POST -H "Authorization: Bearer {{ token }}" -d "name=новое_название" {{ url }}/{{ method }}/1/edit</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success"
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/tasks'
      }
    }
  }
</script>